export default {
  LEARN_MORE_URL: "https://squareup.com/help/us/en/article/5976-get-started-with-email-collection-tools#6e06736579d391a329f45c56c93db318",
};
